import { useEffect } from 'react';

const MicaWhitepaper = () => {
  useEffect(() => {
    // Redirect to the MiCA whitepaper PDF
    window.location.href = 'https://static.opencampus.xyz/documents/MiCA_Whitepaper_V3_OpenCampus_EDU_202509.pdf';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px'
    }}>
      Redirecting...
    </div>
  );
};

export default MicaWhitepaper;